module.exports = __webpack_public_path__ + "img/login-qr.c8b938c8.png";